function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M56.2 46.9c54.8-24.3 117.3-24.6 172.2-.6 4 1.7 7.9 3.6 11.7 5.6l14.1-24.8c-4.7-2.4-9.5-4.7-14.4-6.9C177.5-7 106.7-6.7 44.5 20.9c-5.2 2.3-10.3 4.8-15.3 7.5l14 24.8c4.3-2.2 8.6-4.3 13-6.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.1 67.1l14 24.8c47.1-28.1 105.7-28.6 153.2-1.3l14.1-24.8c-56.2-32.2-125.5-31.7-181.3 1.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.2 102.1c-41.7-23.4-92.8-22.8-134 1.5l.4 1 13.8 23c32.7-17.9 72.1-18.4 105.3-1.5l14.5-24zM90.5 239.4v22.8H14.4v-105h27.5v82.2h48.6zM178.2 179.4h-35.9v82.8h-27.5v-82.8H79v-22.2h99.1v22.2zM269.3 240.2v22h-79.2v-105h77.4v22h-49.9V196h44.2v21.1h-44.2v23.1h51.7z"
})));